/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserCalculationsLastDatesResource } from './userCalculationsLastDatesResource';
import { UserCalculationsLastDates200ResponseMeta } from './userCalculationsLastDates200ResponseMeta';


export interface UserCalculationsLastDates200Response { 
    data: UserCalculationsLastDatesResource;
    meta: UserCalculationsLastDates200ResponseMeta;
}

